import { FC } from 'react';
import Link from 'next/link';
import { Box, Typography } from '@mui/material';
import { clsx, useStyles } from '@sweatpals/react-ui-kit';
import { createOwnEventSectionStyles } from './create-own-event-section.styles';
import AppButton from '@/modules/_core/components/buttons/app-button.component';


const CreateOwnEventSection: FC = () => {
	const styles = useStyles(createOwnEventSectionStyles);

	return (
		<Box sx={styles.root}>
			<Box display={'flex'} flexDirection={'column'} gap={'16px'}>
				<Typography sx={styles.title}>
					Want to create your own event for free?
				</Typography>
				<Typography sx={styles.subtitle}>
					SweatPals gives you all the tools you need to set up your own event or community.
				</Typography>
			</Box>
			<Box display={'flex'} gap={'34px'}>
				<Link href='/create/community' legacyBehavior>
					<AppButton sx={styles.button} color="secondary">
						Create Community
					</AppButton>
				</Link>
				<Link href='/create/event' legacyBehavior>
					<AppButton sx={clsx(styles.button, styles.createEventButton)} color="primary">
						Create Event
					</AppButton>
				</Link>
			</Box>
		</Box>
	);
};

export default CreateOwnEventSection;
